import React, { createContext, useState, useRef, useEffect } from 'react'
import { IChannel } from 'shared/types/channel'
import BannerUpload from './banner-upload'
import Footer from './footer'
import OptionalLabel from './optional-label'
import { DescriptionField, Label, NameField, Section, DisableModal } from './sc'
import { NewCollectionProps } from './modal'

const defaultChannel: Partial<IChannel> = {
    is_private: false,
}

type CollectionEditorContextProps = {
    updateChannel: (channel: Partial<IChannel>) => void
    channel: Partial<IChannel>
    newCollectionProps?: NewCollectionProps
    onComplete?: () => void
    setDisabled: (disabled: boolean) => void
}
export const CollectionEditorContext = createContext({} as CollectionEditorContextProps)

type Props = {
    channel?: Partial<IChannel>
    newCollectionProps?: NewCollectionProps
    onComplete?: () => void
}

const CollectionEditor = ({ channel: currentChannel, newCollectionProps, onComplete }: Props) => {
    const [channel, setChannel] = useState<Partial<IChannel>>(currentChannel || defaultChannel)
    const [isDisabled, setDisabled] = useState<boolean>(false)
    const updateChannel = (updateProps: Partial<IChannel>) => setChannel({ ...channel, ...updateProps })
    const value = {
        updateChannel,
        channel,
        newCollectionProps,
        onComplete,
        setDisabled,
    }
    const focusRef = useRef<HTMLInputElement>(null)
    useEffect(() => {
        focusRef.current?.focus()
    }, [])
    return (
        <CollectionEditorContext.Provider value={value}>
            <Section>
                <Label>Name</Label>
                <NameField
                    ref={focusRef}
                    maxLength={50}
                    placeholder="Collection Name"
                    value={channel.display_name || ''}
                    onChange={({ target: { value } }) => {
                        // TODO validate
                        updateChannel({ display_name: value })
                    }}
                ></NameField>
            </Section>
            <Section>
                <OptionalLabel label="Description" />
                <DescriptionField
                    maxLength={200}
                    placeholder="Add a brief description about your collection."
                    as="textarea"
                    value={channel.description || ''}
                    onChange={({ target: { value } }) => {
                        // TODO validate
                        updateChannel({ description: value })
                    }}
                ></DescriptionField>
            </Section>
            <BannerUpload />
            <Section>
                <Footer />
            </Section>
            {isDisabled && <DisableModal />}
        </CollectionEditorContext.Provider>
    )
}
export default CollectionEditor
